import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

import { useNuevoGasto } from '@/shared/hooks/useNuevoGasto';
import { GroupPickerSheet } from './GroupPickerSheet';

/**
 * El botón flotante de «Nuevo gasto», **sólo en móvil**.
 *
 * Desde `lg` no se monta: en escritorio la acción vive arriba del todo de la
 * barra lateral, que es donde se busca lo que se hace a menudo cuando hay un
 * menú permanente delante. Un círculo flotando sobre la esquina inferior
 * derecha es un patrón de móvil —está donde llega el pulgar— y en una pantalla
 * de portátil queda lejos de todo y tapando contenido.
 *
 * A dónde lleva no se decide aquí: eso es `useNuevoGasto`, compartido con la
 * lateral para que las dos no puedan divergir.
 */
export function NewExpenseFAB() {
  const { t } = useTranslation();
  const { oculto, ir, selectorAbierto, cerrarSelector } = useNuevoGasto();

  if (oculto) return null;

  return (
    <>
      <button
        type="button"
        // El atajo `n` busca este botón —o el de la lateral, el que esté
        // visible— y lo pulsa, en vez de repetir la lógica de a dónde va. Ver
        // `useGlobalShortcuts`.
        data-atajo="nuevo-gasto"
        onClick={ir}
        // `new_title` («Nuevo gasto») y no `new` («Nuevo»), que es lo que decía:
        // es un botón sin texto, así que este rótulo es **todo** lo que oye un
        // lector de pantalla, y «Nuevo» a secas no dice nuevo qué. De paso queda
        // igual que el de la barra lateral, que es el mismo gesto.
        aria-label={t('expenses.new_title')}
        className="fixed z-40 flex h-14 w-14 items-center justify-center rounded-full bg-brand text-white shadow-lg transition-transform hover:scale-105 active:scale-95 lg:hidden"
        style={{
          right: 'calc(env(safe-area-inset-right) + 16px)',
          bottom: 'calc(env(safe-area-inset-bottom) + var(--nav-inferior) + 17px)',
        }}
      >
        <Plus size={26} />
      </button>

      {selectorAbierto && <GroupPickerSheet onClose={cerrarSelector} />}
    </>
  );
}
